module.exports = __webpack_public_path__ + "static/media/Porta-Plasmas.8ce2a987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Porta-Plasmas.jpg
// module id = 141
// module chunks = 0